var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAndroid = function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1000 1000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M737.5 417 817 294c5-8 3-18.5-4.5-24-8-5.5-18-3-23.5 5l-45 69.5-19 29-19 29.5c-61-24.5-128.5-38-200-38s-139.5 13.5-200 38l-38-59-45-69.5c-5-8-15.5-10-23.5-5-7.5 5.5-10 16-4.5 24l79.5 123C131.5 485.5 35 615 35 763.5h942c0-148.5-96.5-278-239.5-346.5M304 625c-28 0-50.5-23.5-50.5-52s22.5-52 50.5-52 50.5 23 50.5 52-22.5 52-50.5 52m404 0c-28 0-50.5-23.5-50.5-52s22.5-52 50.5-52 50.5 23 50.5 52-23 52-50.5 52"
  })));
};
export default SvgAndroid;